// import { ReactQueryConfigProvider } from "react-query";

import { Amplify } from "aws-amplify";
import appConfig from "../app-config";
import { AuthProvider } from "./AuthProvider";
import { ReactQueryProvider } from "./ReactQueryProvider";
import { ThemeProvider } from "./ThemeProvider";

Amplify.configure(appConfig);

const BaseProvidersContainer = ({ children }: { children: any }) => {
  return (
    <ReactQueryProvider>
      <ThemeProvider>
        <AuthProvider>{children}</AuthProvider>
      </ThemeProvider>
    </ReactQueryProvider>
  );
};

const AppProviders = ({ children }: { children: any }) => {
  return <BaseProvidersContainer>{children}</BaseProvidersContainer>;
};

export default AppProviders;
